import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { reloadOnce } from "@/lib/safe-reload";

declare const __BUILD_VERSION__: string;

export function useVersionCheck() {
  const { data } = useQuery({
    queryKey: ["app-version"],
    queryFn: () =>
      fetch("/version.json", { cache: "no-store" })
        .then((r) => r.json() as Promise<{ version: string }>)
        .catch(() => null),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  useEffect(() => {
    if (data?.version && data.version !== __BUILD_VERSION__) {
      reloadOnce();
    }
  }, [data?.version]);
}
